<ejs-dialog #generateQrCodeDialog [isModal]="true" [showCloseIcon]="true" [visible]="false">
  <ng-template #header>
    {{'i18n.domain.administration.generate-qr-code-dialog.title' | translate}} {{zone?.name}}
  </ng-template>
  <ng-template #content>
    <div class="form-group col-md-12">
      <label class="control-label required">{{'i18n.domain.administration.generate-qr-code-dialog.format' | translate}}</label>
      <app-yes-no-group-button yesLabel='i18n.domain.administration.generate-qr-code-dialog.sticker' noLabel='i18n.domain.administration.generate-qr-code-dialog.qr' [formControl]="isStickerModeControl"></app-yes-no-group-button>
    </div>
    @if (zone?.parkingSpaceNumberDefinition) {
      <div class="form-group col-md-12">
        <div class="d-flex gap-1">
          <label for="parkingSpaceNumber" class="control-label">{{'i18n.domain.administration.generate-qr-code-dialog.parking-space-number' | translate}}</label>
          <ejs-tooltip id='tooltip' content="{{ 'i18n.shared.parking-space-number-information' | translate }}">
            <span class="icon-information"></span>
          </ejs-tooltip>
        </div>
        <input id="parkingSpaceNumber" name="parkingSpaceNumber" type="text" class="form-control" [formControl]="parkingSpaceNumberControl" autocomplete="off" />
      </div>
    }
  </ng-template>
  <ng-template #footerTemplate>
    <button class="btn btn-secondary me-2" (click)="closeDialog()">
      {{'i18n.domain.parker-administration.overview.function-dialog.cancel-button' | translate}}
    </button>
    <button class="btn btn-primary" (click)="generateQrCode()">
      {{'i18n.domain.administration.generate-qr-code-dialog.generate' | translate}}
    </button>
  </ng-template>
</ejs-dialog>
